<div class="content-container">
  <div class="content-centered">
    <h1 class="custom-h1" translate>AUTH.RESET_PASSWORD.DONE.HEADING</h1>

    <div class="visual-container">
      <p translate>AUTH.RESET_PASSWORD.DONE.SUMMARY_1</p>
      <p translate>AUTH.RESET_PASSWORD.DONE.SUMMARY_2</p>
    </div>
  </div>